import { queryString as qs } from '../../jsCore/utils/window'
import { getApiEndpoints } from '../../jsCore/application/api'
import { SOCIAL_BAR_ACTION_TYPES } from './socialBarActionTypes'
import { memoizeFirstCall } from '../../jsCore/utils/fn'
import { warn } from '../../jsCore/application/console'
import { sendVote as sendVoteMock, getVotes as getPostVotesMock } from './mock/socialBarActionsMock'
import { transformGetVotesResponse } from './socialBarDataTransformer'
import { cacheVote } from './socialBarDataSource'
import { throwIfMissingArgument } from '../../jsCore/utils/fn'
import { socialButtonsAction } from '../../jsCore/organizedByType/actions/socialButtonsActions'
import { noop } from '../../jsCore/utils/fn'
import { fetchReactions } from '../../jsCore/providers/actionCounter/currentPostActionCounterProvider'
import { getResponseText } from '../../jsCore/utils/fetch'

export const API_ENDPOINTS = {
  GET_VOTES: 'GET_REACTIONS_VOTES',
  SEND_VOTE: 'SEND_REACTIONS_VOTE',
}

const FEATURE_FLAGS = {
  mockSendVote: qs.reactionsMockSendVote,
  mockGetVotes: qs.reactionsMockGetVotes,
}

const { REACTIONS } = SOCIAL_BAR_ACTION_TYPES

function setReactionsComponentState(reactionsComponentState = throwIfMissingArgument()) {
  return (dispatch, getState) =>
    dispatch({
      type: REACTIONS.SET_REACTIONS_COMPONENT_STATE,
      state: {
        reactionsComponentState,
      },
    })
}

function getStateWithComponentVisibility(
  componentPosition = throwIfMissingArgument(),
  isVisible = throwIfMissingArgument()
) {
  return {
    state: {
      reactionsComponentState: {
        [componentPosition]: { isVisible },
      },
    },
  }
}

function displayReactions(componentPosition) {
  return (dispatch, getState) =>
    dispatch({
      type: REACTIONS.DISPLAY,
      ...getStateWithComponentVisibility(componentPosition, true),
    })
}

function hideReactions(componentPosition) {
  return (dispatch, getState) =>
    dispatch({
      type: REACTIONS.HIDE,
      ...getStateWithComponentVisibility(componentPosition, false),
    })
}

function normalizeComponentPositionStringFor360Analytics(componentPosition) {
  return componentPosition === 'bottom' ? `${componentPosition} bar` : componentPosition
}

function sendVote({ postId, reactionId, componentPosition, reactionTitle }) {
  if (FEATURE_FLAGS.mockSendVote) {
    return sendVoteMock({ postId, reactionId })
  }
  const { SEND_VOTE: { url } } = memoizeFirstCall(
    'SEND_VOTE',
    getApiEndpoints,
    API_ENDPOINTS.SEND_VOTE
  )
  const fullUrl = `${url}?post=${postId}&answer=${reactionId}`
  return (dispatch, getState) => {
    cacheVote({ postId, reactionId })
    getResponseText(fullUrl)
    dispatch({
      type: REACTIONS.SEND_VOTE,
      state: {
        payload: {
          category: 'Article page',
          action: 'article like click',
          label: reactionTitle,
          sub_label: normalizeComponentPositionStringFor360Analytics(componentPosition),
        },
        selectedReaction: reactionId,
        componentPosition: componentPosition, // for analytics
      },
    })
  }
}

function getPostVotes({ postId }) {
  if (FEATURE_FLAGS.mockGetVotes) {
    return getPostVotesMock({ postId })
  }
  return (dispatch, getState) =>
    fetchReactions()
      .then(transformGetVotesResponse)
      .then(state =>
        dispatch({
          type: REACTIONS.GET_VOTES,
          state,
        })
      )
      .catch(warn)
}

export const socialBarActions = {
  displayReactions,
  hideReactions,
  sendVote,
  getPostVotes,
  setReactionsComponentState,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarActions.js